import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type FC, type JSX } from 'react';
import { PaginationType } from '../../types';

interface PaginationProps {
  pagination: PaginationType;
  currentPage: number;
  onPageChange: (page: number) => void;
  itemName?: string; // e.g., "calls", "appointments", "patients"
}

const Pagination: FC<PaginationProps> = ({
  pagination,
  currentPage,
  onPageChange,
  itemName = 'items'
}): JSX.Element => {
  return (
    <div className="flex items-center justify-between pt-4 border-t border-gray-200">
      <div className="text-sm text-gray-600">
        Showing {10} of {pagination.total_items || 0} {itemName}
      </div>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={!pagination.has_previous_page}
          className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
          <span>Previous</span>
        </button>
        <span className="text-sm text-gray-600">
          Page {pagination.page} of {pagination.total_pages}
        </span>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={!pagination.has_next_page}
          className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1 transition-colors"
        >
          <span>Next</span>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
